import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/app/pages/industryAnalysis/SectionHeading";
import { Link } from "react-router-dom";

const IndustryCompany = ({ title, topCompaniesData }) => {
  const { t } = useTranslation();
  const headingPrefix = t("industryAnalysis.industryCompany.headingPrefix");
  const headingSuffix = t("industryAnalysis.industryCompany.headingSuffix");
  const topCompanies = topCompaniesData.map(data => JSON.parse(data));
  
  useEffect(() => {
    const currenturl = window.location.href;
    const element  = document.getElementById("industry-companies-wrapper");

    if (currenturl.includes("#top-companies-anchor")) {
       element.scrollIntoView();
    }
  }, []);

  return (
    <>
      <div className="industryCompaniesWrapper" id="industry-companies-wrapper">
        <div className="container">
          <a className="anchor" name="top-companies-anchor"></a>

          <SectionHeading
            heading={`${headingPrefix} ${title} ${headingSuffix}`}
          />

          <div className="companyContainer row">
            {topCompanies && topCompanies.length && topCompanies.slice(0, Math.min(Number(t("industryAnalysis.industryCompany.limit"))), topCompanies.length).map((company) => (
              <>
                <div className="col-md-4 item pad-lr-0">
                  <div className="company-name">
                    <Link
                      className="sideLink"
                      to={`/business-directory/company-profiles.${company.primaryNameForUrl}.${company.duns}.html`}
                    > 
                      {company.primaryName}
                    </Link>
                  </div>
                  <span className="revenue">{`$${company.yearlyRevenue.toLocaleString(undefined, {maximumFractionDigits: 2})}`}</span>M{" "}|{" "}
                  <span className="country">{company.countryName}</span>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default IndustryCompany;
